// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"d1fcf16d","787":"a542a446","847":"66664c62"}[chunkId] + ".chunk.js";
};